import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_ACTION_ITEMS_ACTION_TYPE } from '../actions/actionItems.actions';

const initialState = null;

const actionItemsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_ACTION_ITEMS_ACTION_TYPE.SET_ACTION_ITEMS:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default actionItemsReducer;
